<template>
  <div class="components__render-content-page" v-bind:style="styleObject">
    <div
      class="render-widget"
      v-for="contentItem in contentItems"
      v-bind:key="contentItem.position"
    >
      <template v-if="contentItem.widget_config.backend">
        <slot v-bind:name="`slot-${contentItem.id}`"><pre>{{contentItem}}</pre></slot>
      </template>
      <component v-else v-bind:is="contentItem.widget_type" v-bind:content-item="contentItem" />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed } from "vue";
  import { useStore } from "vuex";
  
  const store = useStore();
  
  const contentPage = computed(() => store.state.gon.content_page)
  const contentItems = computed(() => {
    return ((contentPage.value || {}).content_items || []).sort(
      (a: any, b: any) => a.position - b.position,
    );
  });
  const styleObject = computed(() => {
    const styles: Record<string, string> = {};

    if (contentPage.value.page_width)
      styles["max-width"] = contentPage.value.page_width + "px";

    if (contentPage.value.plain_style) styles["margin"] = "auto";

    return styles;
  });
</script>
